import React from 'react';
import {
    FlexSpace,
    ItemMenuButton,
    ItemMenuWrapper,
    LinkedMenuItemWrapper,
    LogoWrapper,
    MenuItemsWrapper,
    MenuItemText,
    StyledSkeleton,
    UserMenuWrapper,
} from './Header.style';

export const HeaderSkeleton = React.memo(({ isOnTop }: { isOnTop: boolean }) => {
    return (
        <>
            <LogoWrapper isontop={isOnTop.toString()}>
                <StyledSkeleton variant={'rounded'} height="25px" width="178px" />
            </LogoWrapper>
            <MenuItemsWrapper>
                <LinkedMenuItemWrapper to={'/'}>
                    <MenuItemText>
                        <StyledSkeleton variant={'rounded'} height="20px" width="170px" />
                    </MenuItemText>
                </LinkedMenuItemWrapper>
            </MenuItemsWrapper>
            <FlexSpace />
            <ItemMenuWrapper>
                <ItemMenuButton>
                    <StyledSkeleton variant={'rounded'} height="20px" width="125px" />
                </ItemMenuButton>
            </ItemMenuWrapper>
            <UserMenuWrapper>
                <StyledSkeleton variant={'rounded'} height="20px" width="155px" />
            </UserMenuWrapper>
        </>
    );
});
